<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()" autocomplete="off">

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.dialogs.description' |translate}}</mat-label>
      <input matInput type="text" [formControl]="descriptionControl" />
    </mat-form-field>

    <button type="reset" mat-raised-button (click)="clean()">Clean</button>
    <button type="submit" mat-raised-button color="primary">Apply</button>
  </form>
</div>
